module.exports = __webpack_public_path__ + "img/Frame1.d155f0fe.png";